<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container">

    <div class="row mb-3">
      <div class="col-12">
        <h1 [ngClass]="{'page-title': useRebrandedLayout }" class="mt-4">
          {{ pageTitle }}
        </h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-3" [ngClass]="{'page-content-title': useRebrandedLayout }" [innerHTML]="pageContent">
      </div>
    </div>
  </div>
</div>
